// Currently supported locales
export const SUPPORTED_LOCALES = ['en', 'ru', 'uk', 'pl', 'ko'] as const;
export type SupportedLocale = typeof SUPPORTED_LOCALES[number];

// Default locale
export const DEFAULT_LOCALE: SupportedLocale = 'en';

// Import all locales
import * as en from './en';
import * as ru from './ru';
import * as uk from './uk';
import * as pl from './pl';
import * as ko from './ko';

// Locale data structure
export const localeData = {
  en,
  ru,
  uk,
  pl,
  ko
} as const;

// Convenience functions to get localized data
export const getFullQuestionPool = (locale: SupportedLocale = DEFAULT_LOCALE) => {
  return localeData[locale].fullQuestionPool;
};

export const getDemoQuestions = (locale: SupportedLocale = DEFAULT_LOCALE) => {
  return localeData[locale].demoQuestions;
};

// getRandomQuestions function removed as it's not implemented in locale files

export const getUITexts = (locale: SupportedLocale = DEFAULT_LOCALE) => {
  return localeData[locale].uiTexts;
};

// Language metadata
export const getLanguageInfo = (locale: SupportedLocale) => {
  return localeData[locale].uiTexts.language;
};

export const getAllLanguages = () => {
  return SUPPORTED_LOCALES.map(locale => ({
    ...getLanguageInfo(locale),
    isDefault: locale === DEFAULT_LOCALE
  }));
}; 